'use strict';

var _ = require('lodash');
var DaysToDepartureCalculatorService = function DaysToDepartureCalculatorService(MomentConstants) {
  /**
   * Calculates calendar days (midnights) between departureDate and dateTime, using specified time zone data.
   * @param dateTime - event time in UTC time zone
   * @param timeZoneData - object with time zone information. Contains offset, and DST ranges list
   * @param departureDate - departureDate in origin airport time zone
   * @return {number}
   */
  function calculate(dateTime, timeZoneData, departureDate) {
    var airportTimeZoneOffset = getTimeZoneOffsetForSpecifiedDate(dateTime, timeZoneData);
    var dateTimeWithAirportOffsetApplied = dateTime.add(airportTimeZoneOffset, 'minutes');
    var differenceInDays = departureDate.startOf('day').diff(dateTimeWithAirportOffsetApplied.startOf('day'), 'days');
    return Math.max(0, differenceInDays);
  }

  /**
   * Calculates overall offset (in minutes) for specified dateTime. Ensures that DST offset is applied.
   */
  function getTimeZoneOffsetForSpecifiedDate(dateTime, timeZoneData) {
    var utcOffset = timeZoneData.offset;
    var dstOffset = getDaylightSavingTimeOffset(dateTime, timeZoneData.daylightSavingTimes);
    return utcOffset + dstOffset;
  }

  /**
   * Calculates only DST offset (in minutes) for specified dateTime.
   */
  function getDaylightSavingTimeOffset(dateTime, daylightSavingTimeList) {
    if (_.isArray(daylightSavingTimeList) && !_.isEmpty(daylightSavingTimeList)) {
      var dateTimeStr = dateTime.value.format(MomentConstants.FORMATS.DATE_TIME_ISO_WITHOUT_SECONDS);
      for (var i = 0; i < daylightSavingTimeList.length; i++) {
        var range = daylightSavingTimeList[i];
        // using string comparison to avoid object creation
        if (range.effectiveDate <= dateTimeStr && dateTimeStr < range.discontinueDate) {
          return range.adjustment;
        }
      }
    }
    return 0;
  }
  return {
    calculate: calculate
  };
};
DaysToDepartureCalculatorService.$inject = ['MomentConstants'];
module.exports = DaysToDepartureCalculatorService;